import { QueryClient } from '@tanstack/react-query';

/**
 * QueryClient compartido para todo el backoffice.
 *
 * Defaults pensados para un CRM con datos que cambian con frecuencia:
 * - `staleTime: 30s` — los datos se consideran "frescos" 30s tras el último fetch.
 *   Durante ese tiempo, volver a una pantalla no dispara refetch (cache hit).
 *   Pasados 30s, próximo render/mount refetch en background pero sirve los datos
 *   viejos primero (stale-while-revalidate).
 * - `gcTime: 5min` — datos sin observadores se descartan a los 5min. Suficiente
 *   para volver a una pantalla recién visitada sin perder estado.
 * - `refetchOnWindowFocus: true` (default) — tabear afuera y volver dispara
 *   refetch. Apropiado para un CRM colaborativo donde otro usuario pudo cambiar
 *   datos mientras estabas inactivo.
 * - `retry: 1` — un solo reintento ante error de red. Evita esperas largas en
 *   fallos persistentes; los errores de servidor (4xx/5xx) no se reintentan.
 *
 * Para ajustar por query, pasar overrides al `useQuery` correspondiente.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
    },
  },
});
